import React, { useState, useContext } from 'react';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import "./style.scss";
import UserContext from '../../context/userContext';
import { useNavigate, Link } from "react-router-dom";
import loader from './loader.gif';

const Registration = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const stripe = useStripe();
    const elements = useElements();
    const { setStripeUser, setPremiumToken } = useContext(UserContext);
    const navigate = useNavigate();

    const couponCode = new URLSearchParams(window.location.search).get('couponCode');
    // const source = new URLSearchParams(window.location.search).get('source');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        document.getElementById("loaderDiv").style.display = "block";
        setError(null);
        const { username, email, password } = e.target.elements;

        if (!stripe || !elements) {
            setError("Stripe is not loaded. Please refresh the page and try again.");
            setLoading(false);
            document.getElementById("loaderDiv").style.display = "none";
            return;
        }

        const card = elements.getElement(CardElement);
        const result = await stripe.createPaymentMethod({
            type: 'card',
            card: card,
        });

        if (result.error) {
            setError(result.error.message);
            setLoading(false);
            document.getElementById("loaderDiv").style.display = "none";
            return;
        }

        try {
            const response = await fetch("https://www.calmestcrypto.com/stripe/register1", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    username: username.value,
                    email: email.value,
                    password: password.value,
                    paymentMethodId: result.paymentMethod.id,
                    couponCode: couponCode || null,
                    // source: source || 'direct',
                }),
            });

            const data = await response.json();

            if (data.success) {
                try {
                    const response = await fetch(
                        "https://www.calmestcrypto.com/stripe/login",
                        {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify({
                                identifier: username.value,
                                password: password.value
                            }),
                        }
                    );

                    const data = await response.json();

                    if (response.status !== 200) {
                        throw new Error(data.message);
                    }

                    localStorage.setItem("authToken", data.token);
                    setPremiumToken(data.token);
                    setStripeUser({ username: data.user.username });
                    navigate("/premium");
                } catch (err) {
                    setError(err.message || "An unknown error occurred. Please try again.");
                }
            } else {
                setError(data.error || "An unknown error occurred. Please try again.");
            }
        } catch (err) {
            console.error (err);
            setError("An error occurred. Please try again.");
        } finally {
            setLoading(false);
            document.getElementById("loaderDiv").style.display = "none";
        }
    };

    return (
        <div className="registration-container">
            <div className="registration-form">
                <h2>Unlock Premium Mode</h2>
                {!couponCode ? (
                    <h3 id="price">
                        $5.00 / month
                    </h3>
                ) : (
                    <h3 id="price">
                        <s>$5.00</s>&nbsp;<span style={{color: "red"}}>$1.00</span> / month
                    </h3>
                )}
                
                <form onSubmit={handleSubmit}>
                    <div>
                        <label>Username</label>
                        <input name="username" type="text" required />
                    </div>
                    <div>
                        <label>Email</label>
                        <input name="email" type="email" required />
                    </div>
                    <div>
                        <label>Password</label>
                        <input name="password" type="password" required />
                    </div>
                    <div>
                        <label style={{ marginBottom: "1em" }}>Card Details</label>
                        <CardElement />
                    </div>
                    <div id="loaderDiv">
                        <img src={loader} alt="loader" id="loader" />
                    </div>
                    <div id="agreementDiv">
                        <input type="checkbox" name="agree" id="agree" required />
                        {!couponCode ? (
                            <label htmlFor="agree">I authorize the payment of $5.00 USD to be made from the card entered above. I can cancel or update my subscription anytime.</label>
                        ) : (
                            <label htmlFor="agree">I authorize the payment of $1.00 USD to be made from the card entered above for the first month, and $5.00 per month thereafter. I can cancel or update my subscription anytime.</label>
                        )}

                        
                    </div>
                    <div>
                        <button type="submit" className="submit-button" disabled={loading}>Register and Pay</button>
                    </div>
                    {error && <div className="feedback">{error}</div>}
                </form>
                <p>
                    Already have an account?&nbsp;
                    <Link to="/login" className="login-link">
                        Login now!
                    </Link>
                </p>
            </div>
        </div>
    );
};

export default Registration;
